export default "__VITE_ASSET__awC869dO__"